<template>
  <div class="flex flex-row">
    <TabGroup vertical>
      <TabList class="flex flex-col">
        <result-form-navigation-item
          v-for="(item, index) in tabs"
          :key="index"
          :color="color"
          :required="item.required"
          :status="item.status"
          :addFilesBtn="item.addFilesBtn"
        >
          {{ item.name }}
        </result-form-navigation-item>
      </TabList>
      <TabPanels
        class="ml-3 w-full"
        style="max-height: 420px; overflow-y: scroll"
      >
        <slot name="tabContent"></slot>
      </TabPanels>
    </TabGroup>
  </div>
</template>

<script>
import { TabGroup, TabList, TabPanels } from '@headlessui/vue'
import ResultFormNavigationItem from '@/components/layout/result/ResultFormNavigationItem'
import { useResultFormTabs } from '@/services/politicalAction/useResultForm'

export default {
  name: 'ResultFormNavigation',

  components: {
    TabGroup,
    TabList,
    // Tab,
    TabPanels,
    ResultFormNavigationItem,
  },

  props: {
    color: String,
    required: Boolean, // show status icon
    status: Number, // 0 - default, -1 - error, 1 - success
  },

  setup() {
    const { tabs } = useResultFormTabs()
    return { tabs }
  },
}
</script>
